import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
const faqs = [{
  q: '¿El libro es físico o digital?',
  a: 'Es un libro digital en formato PDF. Después de comprarlo, recibirás acceso para descargarlo.'
}, {
  q: '¿Necesito experiencia previa en crecimiento personal?',
  a: 'No. El libro está escrito para acompañarte de forma clara, profunda y reflexiva, sin necesidad de conocimientos previos.'
}, {
  q: '¿Este libro ofrece consejos médicos?',
  a: 'No. El libro tiene fines educativos, reflexivos y de crecimiento personal. No sustituye asesoramiento médico, psicológico, nutricional o profesional.'
}, {
  q: '¿Puedo leerlo desde mi teléfono?',
  a: 'Sí. Puedes leerlo desde tu teléfono, tableta, computadora o cualquier dispositivo compatible con archivos PDF.'
}, {
  q: '¿Para quién es este libro?',
  a: 'Para personas que desean vivir con más equilibrio, claridad, propósito, conexión emocional y armonía interior.'
}, {
  q: '¿Qué hace diferente a este libro?',
  a: 'Su enfoque integral. No trata una sola área de la vida, sino que une cuerpo, mente, emociones, relaciones, disciplina, intuición y propósito en un mismo camino de transformación.'
}];
export const FAQ: React.FC = () => {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="relative bg-navy-deep py-28 lg:py-40 overflow-hidden" data-id="element-124">
      <div className="relative max-w-3xl mx-auto px-6 lg:px-8" data-id="element-125">
        <div className="text-center mb-14" data-id="element-126">
          <Reveal data-id="element-127">
            <SectionEyebrow data-id="element-128">Preguntas frecuentes</SectionEyebrow>
          </Reveal>
          <Reveal delay={0.1} data-id="element-129">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ivory leading-[1.1]" style={{
            fontWeight: 300
          }} data-id="element-130">
              Resolvemos{' '}
              <span className="italic gold-text" style={{
              fontWeight: 400
            }} data-id="element-131">
                tus dudas
              </span>
            </h2>
          </Reveal>
        </div>

        <div className="space-y-3" data-id="element-132">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <Reveal key={i} delay={i * 0.04} data-id="element-133">
                <div className={`rounded-xl border transition-colors duration-300 ${isOpen ? 'border-gold/40 bg-navy-mid/60' : 'border-ivory/10 bg-navy-mid/30 hover:border-gold/25'}`} data-id="element-134">
                  <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 p-6 text-left" aria-expanded={isOpen} data-id="element-135">
                    <span className="font-serif text-lg lg:text-xl text-ivory leading-snug" data-id="element-136">
                      {f.q}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.4,
                  ease: [0.22, 1, 0.36, 1]
                }} className="w-9 h-9 rounded-full border border-gold/30 flex items-center justify-center flex-shrink-0" data-id="element-137">
                      <PlusIcon className="w-4 h-4 text-gold" strokeWidth={1.5} data-id="element-138" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-139">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.5,
                  ease: [0.22, 1, 0.36, 1]
                }} className="overflow-hidden" data-id="element-140">
                        <p className="px-6 pb-6 pr-16 text-ivory/65 leading-relaxed font-light" data-id="element-141">
                          {f.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
};